import routerHistory from '../../routerHistory';
import * as classroomActions from '../../actions/classroom/classroomActions';
import * as routeUtils from './routeUtils';
import { REDUCER } from '../../reducers/reducersConst';
import * as socketSubscriber from '../../services/socketConnection/socketSubscriberService';

/**
 * Indica si un usario ha entrado o no en /classroom
 * @param inClassroom
 * @returns {{type: string, inClassroom: *}}
 */
export let setInClassroom = (inClassroom = false) => {
  return {
    type: REDUCER.ROUTE.SET_IN_CLASSROOM,
    inClassroom
  };
};

/**
 * Indica si un usario ha entrado o no en /book
 * @param inBook
 * @returns {{type: string, inClassroom: *}}
 */
let setInBook = (inBook = false) => {
  return {
    type: REDUCER.ROUTE.SET_IN_BOOK,
    inBook
  };
};

/** Gestiona la lógica si estamos en classroom*/
let manageClassroomPath = store => {
  let { dispatch } = store;

  const inClassroom = routeUtils.inClassroomRoute();
  if (inClassroom) {
    let classId = routeUtils.getClassId();

    dispatch(classroomActions.getClassroomInfo(classId));
    return;
  }

  socketSubscriber.destroyConnection();
  dispatch(setInClassroom(false));
};

let manageBookPath = store => {
  let { dispatch } = store;
  let bookId = routeUtils.getBookId();
  let inBook = bookId !== null && bookId !== undefined;
  dispatch(setInBook(inBook));
};

/** Process path and call services */
let processPath = (store, path) => {
  if (path && store) {
    manageClassroomPath(store, path);
    manageBookPath(store, path);
  }
};

/** START routerHistory listener */
export let start = store => {
  let currentPath = routerHistory.getCurrentLocation().pathname;
  processPath(store, currentPath);

  // ROUTES LISTENER
  routerHistory.listen(function(ev) {
    processPath(store, ev.pathname);
  });
};
